import React from 'react'
import { WorkspaceInfo, WorkspaceInfoPropTypes } from 'ui-components'

const View = (props) => {
  const { loading, workspace } = props

  return (
    <WorkspaceInfo
      loading={loading}
      workspace={workspace}
    />
  )
}

View.propTypes = WorkspaceInfoPropTypes

export { View }
